export default __webpack_public_path__ + "locales/fr/SendInviteDialog.json?hash=bc642e6f5084fbf3e1f60e973d46230f";